import { lazy } from 'react';
export var TasksPageAsync = lazy(function () { return import('./TasksPage'); });
